import { render, staticRenderFns } from "./PatientCreate.vue?vue&type=template&id=7a56dc4b&scoped=true&"
import script from "./PatientCreate.vue?vue&type=script&lang=js&"
export * from "./PatientCreate.vue?vue&type=script&lang=js&"
import style0 from "./PatientCreate.vue?vue&type=style&index=0&id=7a56dc4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a56dc4b",
  null
  
)

export default component.exports